"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Layout = void 0;
exports.Layout = {
    Vertical: 'vertical',
    Horizontal: 'horizontal'
};
//# sourceMappingURL=layout.js.map